import Basic from './Basic';
import Background from './Background';
import Avatar from './Avatar';
import Logo from './Logo';
import HeartIcon from './HeartIcon';
import ActionIcons from './ActionIcons';
import ActionIcon from './ActionIcon';
import UploadTrigger from './UploadTrigger';
import ImageNumberComponent from './ImageNumber';

export const Image = Basic;
export const BackgroundImage = Background;
export const AvatarImage = Avatar;
export const LogoImage = Logo;
export const FavoriteIcon = HeartIcon;
export const ImageActionIcons = ActionIcons;
export const ImageActionIcon = ActionIcon;
export const ImageUploaderTrigger = UploadTrigger;
export const ImageNumber = ImageNumberComponent;
